"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Tooltip/common.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);




























// The defaults the class components declared as static defaultProps.
 const DEFAULT_TYPE = 'light'; exports.DEFAULT_TYPE = DEFAULT_TYPE
 const DEFAULT_PLACE = 'left'; exports.DEFAULT_PLACE = DEFAULT_PLACE
 const DEFAULT_CONTENT = _react2.default.createElement('div', { style: { color: 'red' }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}, "EMPTY"); exports.DEFAULT_CONTENT = DEFAULT_CONTENT
 const noop = () => undefined; exports.noop = noop

 const getTooltipPosition = (
  tooltipTargetDOM,
  tooltipContentDOM,
  place,
  hideArrow,
  offset = {},
) => {
  if (!tooltipTargetDOM || !tooltipContentDOM) return {}

  const tooltipTargetRect = tooltipTargetDOM.getBoundingClientRect()
  const tooltipContentRect = tooltipContentDOM.getBoundingClientRect()

  const {
    left: targetX, top: targetY,
    width: targetWidth, height: targetHeight,
  } = tooltipTargetRect
  const { width: contentWidth, height: contentHeight } = tooltipContentRect
  let baseOffset = 10

  if (window.innerWidth <= 560 || hideArrow) baseOffset = 0

  const requestedOffset = {
    top: offset.top || 0,
    right: offset.right || 0,
    bottom: offset.bottom || 0,
    left: offset.left || 0,
  }
  const verticalOffset = requestedOffset.top - requestedOffset.bottom
  const horizontalOffset = requestedOffset.left - requestedOffset.right

  const positions = {
    "top": {
      top: targetY - contentHeight - baseOffset + verticalOffset,
      left: targetX - contentWidth / 2 + targetWidth / 2 + horizontalOffset,
    },
    "bottom": {
      top: targetY + targetHeight + baseOffset + verticalOffset,
      left: targetX - contentWidth / 2 + targetWidth / 2 + horizontalOffset,
    },
    "bottom-left": {
      top: targetY + targetHeight + baseOffset + verticalOffset,
      left: targetX + horizontalOffset,
    },
    "left": {
      top: targetY - contentHeight / 2 + targetHeight / 2 + verticalOffset,
      left: targetX - contentWidth - baseOffset + horizontalOffset,
    },
    "right": {
      top: targetY - contentHeight / 2 + targetHeight / 2 + verticalOffset,
      left: targetX + targetWidth + baseOffset + horizontalOffset,
    },
  } 
  const position = positions[place]

  const screenPadding = 15
  if (position.left + contentWidth > window.innerWidth) { /* too far right */
    position.left = window.innerWidth - contentWidth - screenPadding
  } else if (position.left < 0) { /* too far left */
    position.left = screenPadding
  }

  if (position.top + contentHeight > window.innerHeight) {
    position.top = window.innerHeight - contentHeight - screenPadding
  } else if (position.top < 0) {
    position.top = screenPadding
  }
  return position
}; exports.getTooltipPosition = getTooltipPosition

 const getToolTipArrowPosition = (
  tooltipTargetDOM,
  tooltipPosition,
  place,
) => {
  const targetRect = tooltipTargetDOM.getBoundingClientRect()
  const targetHalfWidth = (targetRect.right - targetRect.left) / 2
  const targetHalfHeight = (targetRect.bottom - targetRect.top) / 2
  // SAFETY: `left`/`top` are undefined only for an unmeasured `{}` position;
  // the arithmetic then yields NaN exactly as the JS did.
  return place.includes('top') || place.includes('bottom')
    ? { left: Math.abs(targetRect.left + targetHalfWidth - (tooltipPosition.left )) }
    : { top: Math.abs(targetRect.top + targetHalfHeight - (tooltipPosition.top )) }
}; exports.getToolTipArrowPosition = getToolTipArrowPosition

const COLOR_CLASS_NAMES = {
  dark: 'blm-tooltip--dark',
  light: 'blm-tooltip--light',
} 

const PLACE_CLASS_NAMES = {
  "top": 'blm-tooltip--top',
  "bottom": 'blm-tooltip--bottom',
  "bottom-left": 'blm-tooltip--bottom',
  "right": 'blm-tooltip--right',
  "left": 'blm-tooltip--left',
} 

 const getTooltipTypeClass = (
  { type, place },
) => _classBuilder2.default.call(void 0, 
  type && COLOR_CLASS_NAMES[type],
  place && PLACE_CLASS_NAMES[place],
); exports.getTooltipTypeClass = getTooltipTypeClass



// Hover and click tooltips attach native listeners to their direct children, so
// every valid child element is cloned with a callback ref recorded under
// `ref-<index>`, which also forwards the node to the child's own ref. Like the
// class components, the callback is new on every render: React detaches and
// re-attaches it on each commit, which keeps a replaced child's entry current.
 const useChildRefs = () => {
  const childRefs = _react2.default.useRef({})

  const setChildRef = (key, childRef) => (node) => {
    if (node) childRefs.current[key] = node
    else delete childRefs.current[key]

    if (typeof childRef === 'function') childRef(node)
    else if (childRef) childRef.current = node
  }

  const cloneChildrenWithRefs = (children) => _react2.default.Children.map(
    children,
    (child, i) => _react2.default.isValidElement(child)
      // React 19 keeps an element's ref on props.ref; the deprecated
      // element.ref the class components read is an alias for it.
      ? _react2.default.cloneElement(child, { ref: setChildRef(`ref-${i}`, child.props.ref) })
      : child,
  )

  return { childRefs, cloneChildrenWithRefs }
}; exports.useChildRefs = useChildRefs
